
import type { RelatedPrompts } from '@empathyco/playboard-core-domain'
import type { DataTableColumn } from '../../models'

import { computed, defineComponent, onMounted, ref } from 'vue'
import DataTable from '../../components/crud/data-table.component.vue'
import { EpbPill } from '../../components/shared/epb-pill'
import { EpbSwitch } from '../../components/shared/epb-switch'

import { useRelatedPrompts } from '../../composables'
import { useEpb } from '../../composables/use-epb'
import { FilterIdEnum } from '../../enums/filter-id.enum'

export default defineComponent({
  name: 'RelatedPromptsOverview',
  components: { DataTable, EpbPill, EpbSwitch },
  setup(props, ctx) {
    const baseClass = 'related-prompts-overview'

    const { $epb } = useEpb()

    const { messages, loading, loadAllRelatedPrompts, updateRelatedPrompt } = useRelatedPrompts(ctx)

    const relatedPrompts = ref<RelatedPrompts[]>([])

    const columns = computed<Array<DataTableColumn>>(() => {
      return [
        {
          id: 'suggestionText',
          text: messages.overview.table.name,
          width: '200%',
        },
        {
          id: 'uuid',
          copyToClipboard: true,
          text: messages.overview.table.id,
          width: '150%',
        },
        {
          id: 'pivots.lang',
          text: messages.overview.table.language,
        },
        {
          id: 'nextQueries',
          text: messages.overview.table.nextQueries,
          width: '200%',
        },
        {
          id: 'active',
          text: messages.overview.table.state,
          width: '60%',
        },
      ]
    })

    const data = computed(() => {
      return relatedPrompts.value.map(relatedPrompts => {
        const langValue = relatedPrompts.pivots[FilterIdEnum.LANG]
        return {
          ...relatedPrompts,
          pivots: {
            [FilterIdEnum.LANG]: $epb.messages.filters.values[FilterIdEnum.LANG][langValue],
          },
        }
      })
    })

    const setEnabled = (item: RelatedPrompts): void => {
      const itemToUpdated = relatedPrompts.value.find(relatedPrompt => relatedPrompt.id === item.id)
      itemToUpdated.active = !itemToUpdated.active
      itemToUpdated.type = 'CURATED'
      updateRelatedPrompt(itemToUpdated)
    }

    onMounted(async () => {
      relatedPrompts.value = await loadAllRelatedPrompts()
    })

    return {
      baseClass,
      loading,
      columns,
      data,
      setEnabled,
    }
  },
})
